import {
  BiSolidMessageRounded,
  BiSolidMessageRoundedError,
} from "react-icons/bi";
import { MdArchive, MdFavorite } from "react-icons/md";

export const headToolsList = [
  {
    icon: <BiSolidMessageRounded />,
    span: "Tous les messages",
  },
  {
    icon: <BiSolidMessageRoundedError />,
    span: "Messages non lus",
  },
  {
    icon: <MdFavorite />,
    span: "Mes favoris",
  },
  // {
  //   icon: <MdArchive />,
  //   span: "Messages archivés",
  // },
];
